module.exports = function toPositive(number) {
  return number < 0 ? 0 : (+number || 0);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/helper/toPositive.js
// module id = 280
// module chunks = 0